import { useMutation } from '@tanstack/react-query';

import AppointmentsRepository from '@/repositories/members/AppointmentsRepository';
import { JoinVideoAppointmentParams } from '@/types/videoSessions';

export const useJoinVideoAppointment = () => {
  const repository = AppointmentsRepository();

  return useMutation({
    mutationFn: (data: JoinVideoAppointmentParams) => repository.joinVideoAppointment(data)
  });
};
